import type { UserUuid } from "../identity";
// src/types/emailConfig.ts

export interface BaseEmailConfig {
	id: number;
	name: string;
	host: string;
	port: number;
	encryption: 'tls' | 'ssl';
	username: string;
	from_address: string;
	from_name: string;
	is_active: boolean;
	is_verified: boolean;
	created_at: string;
	updated_at: string;
}

export interface CompanyEmailConfig extends BaseEmailConfig {
	company_id: number;
}

export interface UserEmailConfig extends BaseEmailConfig {
	user_id: UserUuid;
}

export interface EmailConfigRequest {
	name: string;
	host: string;
	port: number;
	encryption: 'tls' | 'ssl';
	username: string;
	password: string;
	from_address: string;
	from_name: string;
	test_email?: string;
}

export interface CreateCompanyEmailConfigRequest extends EmailConfigRequest {
	company_id: number;
}

export interface CreateUserEmailConfigRequest extends EmailConfigRequest {
	user_id: UserUuid;
}

export interface TestConfigRequest {
	test_email: string;
}

export interface TestConfigResponse {
	success: boolean;
	message?: string;
	error?: string;
}

export interface EmailConfigResponse<T = CompanyEmailConfig | UserEmailConfig> {
	status: 'success' | 'error';
	data?: T;
	test_result?: TestConfigResponse;
	message?: string;
}

export interface EmailConfigListResponse<T = CompanyEmailConfig | UserEmailConfig> {
	status: 'success' | 'error';
	data: T[];
	message?: string;
}

// Common SMTP provider presets
export interface SMTPProvider {
	name: string;
	host: string;
	port: number;
	encryption: 'tls' | 'ssl';
	instructions?: string;
}

export const SMTP_PROVIDERS: SMTPProvider[] = [
	{
		name: 'Gmail',
		host: 'smtp.gmail.com',
		port: 587,
		encryption: 'tls',
		instructions: 'Use your Gmail address and an App Password (not your regular password)'
	},
	{
		name: 'Outlook/Hotmail',
		host: 'smtp-mail.outlook.com',
		port: 587,
		encryption: 'tls',
		instructions: 'Use your Outlook address and password'
	},
	{
		name: 'Yahoo',
		host: 'smtp.mail.yahoo.com',
		port: 587,
		encryption: 'tls',
		instructions: 'Use your Yahoo address and an App Password'
	},
	{
		name: 'Custom SMTP',
		host: '',
		port: 587,
		encryption: 'tls',
		instructions: 'Enter your custom SMTP server details'
	}
];